import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=28b1326d&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=28b1326d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1326d",
  null
  
)

export default component.exports